import React, { useState, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from '@mui/styles';
import { WEB_MAIN_COLOR, WEB_SECONDORY_COLOR, FONT_FAMILY } from "../common/sharedFunctions"
import Grid from '@mui/material/Grid';
import Button from "components/CustomButtons/Button.js";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import { api } from 'common';
import { colors } from '../components/Theme/WebTheme';
import { Typography, Snackbar, Alert, Divider, Paper, IconButton, Snackbar as MuiSnackbar } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SaveIcon from '@mui/icons-material/Save';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles((theme) => ({
    tabs: props => ({
        "& .MuiTabs-indicator": {
            backgroundColor: '#1A1D2E',
            height: 3,
        },
        "& .MuiTab-root.Mui-selected": {
            color: '#1A1D2E',
            fontFamily: FONT_FAMILY,
            fontWeight: 'bold',
        },
        "& .MuiTab-root": {
            fontFamily: FONT_FAMILY,
        }
    }),
    rootRtl: {
        "& label": {
          right: 10,
          left: "auto",
          paddingRight: 20,
          fontFamily: FONT_FAMILY,
        },
        "& legend": {
          textAlign: "right",
          marginRight: 20,
          fontFamily: FONT_FAMILY,
        },
        "& input": {
          fontFamily: FONT_FAMILY,
        },
      },
      rootRtl3: {
        "& label": {
          right: 10,
          left: "auto",
          paddingRight: 20,
          fontFamily: FONT_FAMILY,
        },
        "& legend": {
          textAlign: "right",
          marginRight: 20,
          fontFamily: FONT_FAMILY,
        },
        "& input": {
          fontFamily: FONT_FAMILY,
        },
      },
      rootRtl_1: props => ({
        "& label": {
          right: 10,
          left: "auto",
          paddingRight: 33,
          fontFamily: FONT_FAMILY,
        },
        "& legend": {
          textAlign: "right",
          marginRight: 25,
          fontFamily: FONT_FAMILY,
        },
        "& label.Mui-focused": {
          color: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiInput-underline:after": {
          borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiFilledInput-underline:after": {
          borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiOutlinedInput-root": {
          "&.Mui-focused fieldset": {
            borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
          },
        },
        "& input": {
          fontFamily: FONT_FAMILY,
        },
      }),
    textField: {
        "& input": {
            fontFamily: FONT_FAMILY,
        },
    },
    buttonStyle: props => ({
        margin: 0,
        minWidth: 250,
        height: 40,
        borderRadius: "30px",
        backgroundColor: '#ffce00',
        color: '#1A1D2E',
        fontWeight: "bold",
        fontSize: "16px",
        fontFamily: FONT_FAMILY,
    }),
    switchLabel: {
        fontFamily: FONT_FAMILY
    }
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

// Passerelles actives
const ACTIVE_PROVIDERS = ['flutterwave', 'stripe', 'cash'];

export default function PaymentSettings() {
    const { t,i18n } = useTranslation();
    const isRTL = i18n.dir();
    const [value, setValue] = React.useState(0);
    const {
        editPaymentMethods
    } = api;

    const [paymentSettings, setPaymentSettings] = useState();
    const [oldPaymentSettings, setOldPaymentSettings] = useState();
    const paymentmethods = useSelector(state => state.paymentmethods);
    const dispatch = useDispatch();
    const settings = useSelector((state) => state.settingsdata.settings);
    const classes = useStyles({settings});
    const offlinetopupdata = useSelector((state) => state.offlinetopupdata);

    // Offline topup settings state
    const [otEnabled, setOtEnabled] = useState(false);
    const [otMinAmount, setOtMinAmount] = useState('');
    const [otInstructions, setOtInstructions] = useState('');
    const [otMethods, setOtMethods] = useState([{ operator: '', phoneNumber: '', accountName: '' }]);
    const [otContactPhone, setOtContactPhone] = useState('');
    const [otSaving, setOtSaving] = useState(false);
    const [otSnack, setOtSnack] = useState(false);
    
    useEffect(() => {
        const copyOfProviders = JSON.parse(JSON.stringify(paymentmethods.providers));
      if (paymentmethods.providers) {
        setPaymentSettings(paymentmethods.providers); 
        setOldPaymentSettings(copyOfProviders); 
      }else{
        setPaymentSettings(null);
        setOldPaymentSettings(null);
      }
    }, [paymentmethods.providers]);

    useEffect(() => {
        dispatch(api.fetchOfflineTopupSettings());
    }, []);

    useEffect(() => {
        const s = offlinetopupdata.settings;
        if (s) {
            setOtEnabled(s.enabled || false);
            setOtMinAmount(s.minimumAmount !== undefined ? String(s.minimumAmount) : '');
            setOtInstructions(s.instructions || '');
            setOtMethods(s.paymentMethods && s.paymentMethods.length > 0 ? s.paymentMethods : [{ operator: '', phoneNumber: '', accountName: '' }]);
            setOtContactPhone(s.contactPhone || '');
        }
    }, [offlinetopupdata.settings]);

    const handleOtSave = async () => {
        const payload = {
            enabled: otEnabled,
            minimumAmount: parseFloat(otMinAmount) || 0,
            instructions: otInstructions.trim(),
            paymentMethods: otMethods.filter(m => m.operator.trim() || m.phoneNumber.trim()),
            contactPhone: otContactPhone.trim(),
        };
        setOtSaving(true);
        try {
            await dispatch(api.editOfflineTopupSettings(payload));
            setOtSnack(true);
        } catch (e) {
            console.error(e);
        } finally {
            setOtSaving(false);
        }
    };

    const otAddMethod = () => setOtMethods([...otMethods, { operator: '', phoneNumber: '', accountName: '' }]);
    const otRemoveMethod = (i) => { const u = otMethods.filter((_, idx) => idx !== i); setOtMethods(u.length ? u : [{ operator: '', phoneNumber: '', accountName: '' }]); };
    const otUpdateMethod = (i, field, val) => setOtMethods(otMethods.map((m, idx) => idx === i ? { ...m, [field]: val } : m));

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleCheck = (e) => {
        let pgName = e.target.name.split("|")[0];
        let pgKey = e.target.name.split("|")[1];
        let ps = Object.assign({}, paymentSettings);;
        ps[pgName][pgKey] = e.target.checked;
        setPaymentSettings(ps);
    }

    const handleText = (e) => {
        let pgName = e.target.name.split("|")[0];
        let pgKey = e.target.name.split("|")[1];
        let ps = Object.assign({}, paymentSettings);;
        ps[pgName][pgKey] = (pgName === 'payulatam') && (pgKey === 'merchantId' || pgKey === 'accountId') && e.target.value.length> 0? parseInt(e.target.value): e.target.value;
        setPaymentSettings(ps);
    }

    const handleSubmit = () => {
        if(settings.AllowCriticalEditsAdmin){
            dispatch(editPaymentMethods(paymentSettings));
        }else{
            alert(t("demo_mode"))
        }
    }

    return (
        paymentSettings?
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange}  variant="scrollable" aria-label="basic tabs example" className={classes.tabs}>
                    <Tab label={t('offline_topup_title')} {...a11yProps(0)} />
                    {Object.keys(paymentSettings).filter(pgname => ACTIVE_PROVIDERS.includes(pgname)).map((pgname, index) =>
                        <Tab key={"key"+index} label={t(pgname)} {...a11yProps(index + 1)} />
                    )}
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <Box sx={{ maxWidth: 680, pt: 1 }}>
                    <FormControlLabel
                        control={<Switch checked={otEnabled} onChange={e => setOtEnabled(e.target.checked)} color="primary" />}
                        label={<Typography style={{ fontFamily: FONT_FAMILY, fontSize: 14 }}>{t('offline_topup_enable')}</Typography>}
                    />
                    <Box sx={{ mt: 2 }}>
                        <TextField
                            fullWidth size="small"
                            label={t('offline_topup_min_amount_label') + ' (' + (settings?.symbol || '') + ')'}
                            type="number" value={otMinAmount}
                            onChange={e => setOtMinAmount(e.target.value)}
                            inputProps={{ min: 0 }}
                            InputProps={{ style: { fontFamily: FONT_FAMILY } }}
                            InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                        />
                    </Box>
                    <Box sx={{ mt: 2 }}>
                        <TextField
                            fullWidth size="small"
                            label={t('offline_topup_contact_phone_label')}
                            value={otContactPhone}
                            onChange={e => setOtContactPhone(e.target.value)}
                            placeholder="+261 34 00 000 00"
                            InputProps={{ style: { fontFamily: FONT_FAMILY } }}
                            InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                        />
                    </Box>
                    <Box sx={{ mt: 2 }}>
                        <TextField
                            fullWidth multiline rows={4}
                            label={t('offline_topup_instructions_label')}
                            value={otInstructions}
                            onChange={e => setOtInstructions(e.target.value)}
                            placeholder={t('offline_topup_instructions_placeholder')}
                            InputProps={{ style: { fontFamily: FONT_FAMILY } }}
                            InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                        />
                    </Box>
                    <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle2" style={{ fontFamily: FONT_FAMILY, fontWeight: 700, marginBottom: 8 }}>
                            {t('offline_topup_payment_methods')}
                        </Typography>
                        {otMethods.map((m, i) => (
                            <Paper key={i} elevation={0} sx={{ border: '1px solid #E2E8F0', borderRadius: 2, p: 2, mb: 2 }}>
                                <Grid container spacing={1.5} alignItems="center">
                                    <Grid item xs={12} sm={4}>
                                        <TextField fullWidth size="small" label={t('offline_topup_operator')} value={m.operator}
                                            onChange={e => otUpdateMethod(i, 'operator', e.target.value)}
                                            InputProps={{ style: { fontFamily: FONT_FAMILY } }} InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }} />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField fullWidth size="small" label={t('phone')} value={m.phoneNumber}
                                            onChange={e => otUpdateMethod(i, 'phoneNumber', e.target.value)}
                                            InputProps={{ style: { fontFamily: FONT_FAMILY } }} InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }} />
                                    </Grid>
                                    <Grid item xs={10} sm={3}>
                                        <TextField fullWidth size="small" label={t('account_name')} value={m.accountName}
                                            onChange={e => otUpdateMethod(i, 'accountName', e.target.value)}
                                            InputProps={{ style: { fontFamily: FONT_FAMILY } }} InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }} />
                                    </Grid>
                                    <Grid item xs={2} sm={1} sx={{ textAlign: 'right' }}>
                                        <IconButton size="small" color="error" onClick={() => otRemoveMethod(i)} disabled={otMethods.length === 1}>
                                            <DeleteOutlineIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Paper>
                        ))}
                        <Button size="sm" onClick={otAddMethod} variant="outlined"
                            style={{ fontFamily: FONT_FAMILY, backgroundColor: 'transparent', border: '1px solid #1A1D2E', color: '#1A1D2E', borderRadius: 20, marginBottom: 16 }}>
                            + {t('offline_topup_add_method')}
                        </Button>
                    </Box>
                    <Button size="lg" onClick={handleOtSave} className={classes.buttonStyle} disabled={otSaving}>
                        {otSaving
                            ? <CircularProgress size={20} style={{ color: '#1A1D2E', margin: 5 }} />
                            : <Typography style={{ fontFamily: FONT_FAMILY, margin: 5 }}>{t('submit')}</Typography>
                        }
                    </Button>
                </Box>
            </TabPanel>
            {Object.keys(paymentSettings).filter(pgname => ACTIVE_PROVIDERS.includes(pgname)).map((pgname, index) =>
                <TabPanel value={value} index={index + 1} key={"key"+index}>
                    <Grid container spacing={2} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }} >
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            {Object.keys(paymentSettings[pgname]).map((pgKey) => 
                                paymentSettings[pgname][pgKey] === true ||  paymentSettings[pgname][pgKey] === false ?
                                <FormControlLabel
                                    key={"key"+pgKey}
                                    style={{ flexDirection: isRTL === 'rtl' ? 'row' : 'row-reverse', paddingTop: 10, paddingBottom: 15, marginLeft: 5 }}
                                    label={pgKey}
                                    labelPlacement={isRTL === 'rtl' ? 'end' : 'end'}
                                    sx={{
                                        '& .MuiFormControlLabel-label': {
                                          fontFamily: FONT_FAMILY,
                                        },
                                      }}
                                    control={
                                        <Switch
                                            checked={paymentSettings[pgname][pgKey]}
                                            onChange={handleCheck}
                                            name={pgname + "|" + pgKey}
                                            color="primary"
                                        />
                                    }
                                />
                                :
                                <TextField
                                    key={"key"+pgKey}
                                    className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                                    variant="outlined"
                                    margin="normal"
                                    type={paymentSettings[pgname][pgKey] === oldPaymentSettings[pgname][pgKey] ? "password" : "text" }
                                    onFocus={(e)=>{
                                        let pgName = e.target.name.split("|")[0];
                                        let pgKey = e.target.name.split("|")[1];
                                        let ps = Object.assign({}, paymentSettings);
                                        ps[pgName][pgKey] = (pgName === 'payulatam') && (pgKey === 'merchantId' || pgKey === 'accountId') && e.target.value.length> 0? "": "";
                                        setPaymentSettings(ps);
                                    }}
                                    required
                                    fullWidth
                                    id={pgname + "|" + pgKey}
                                    label={pgKey}
                                    name={pgname + "|" + pgKey}
                                    autoComplete={pgname + "|" + pgKey}
                                    onChange={handleText}
                                    value={paymentSettings[pgname][pgKey]}
                                    InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                />
                            )}
                            <Button
                                size="lg"
                                onClick={handleSubmit}
                                variant="contained"
                                color="secondaryButton"
                                className={classes.buttonStyle}
                            >
                              <Typography style={{fontFamily: FONT_FAMILY, margin:5}} >{t('submit')}</Typography>
                            </Button>   
                        </Grid>
                    </Grid>
                </TabPanel>
            )}
            <Snackbar open={otSnack} autoHideDuration={3000} onClose={() => setOtSnack(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert onClose={() => setOtSnack(false)} severity="success" sx={{ fontFamily: FONT_FAMILY }}>{t('update_success')}</Alert>
            </Snackbar>
        </Box>
        :null
    );
}